import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import injectSheet from 'react-jss';
import Group from './Group';
import GroupM from './GroupM';

const styles = {
  groups: {
    // display: 'grid',
    // gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    // gridColumnGap: '10px',
    // overflowX: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '10px',
  },
  groupsm: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    // gridColumnGap: '10px',
    overflowX: 'auto',
    // margin: '0 10px',
  },
};

const Groups = ({ classes }) => (
  <div>
    {window.innerWidth >= 600 && (
      <div className={classes.groups}>
        <Group name="Group A" group="A" teamz={['QAT', 'ECU', 'SEN', 'NED']} pickz={['A1', 'A2']} />
        <Group name="Group B" group="B" teamz={['ENG', 'IRN', 'USA', 'WAL']} pickz={['B1', 'B2']} />
        <Group name="Group C" group="C" teamz={['ARG', 'KSA', 'MEX', 'POL']} pickz={['C1', 'C2']} />
        <Group name="Group D" group="D" teamz={['FRA', 'DEN', 'TUN', 'AUS']} pickz={['D1', 'D2']} />
        <Group name="Group E" group="E" teamz={['ESP', 'GER', 'JPN', 'CRC']} pickz={['E1', 'E2']} />
        <Group name="Group F" group="F" teamz={['BEL', 'CAN', 'MAR', 'CRO']} pickz={['F1', 'F2']} />
        <Group name="Group G" group="G" teamz={['BRA', 'SRB', 'SUI', 'CMR']} pickz={['G1', 'G2']} />
        <Group name="Group H" group="H" teamz={['PRT', 'GHA', 'URU', 'KOR']} pickz={['H1', 'H2']} />
      </div>
    )}
    {window.innerWidth < 600 && (
    <Switch>
      <Route
        exact
        path="/groups"
        render={() => (
          <div className={classes.groupsm}>
            <GroupM name="Group A" group="A" teamz={['QAT', 'ECU', 'SEN', 'NED']} pickz={['A1', 'A2']} />
            <GroupM name="Group B" group="B" teamz={['ENG', 'IRN', 'USA', 'WAL']} pickz={['B1', 'B2']} />
            <GroupM name="Group C" group="C" teamz={['ARG', 'KSA', 'MEX', 'POL']} pickz={['C1', 'C2']} />
            <GroupM name="Group D" group="D" teamz={['FRA', 'DEN', 'TUN', 'AUS']} pickz={['D1', 'D2']} />
            <GroupM name="Group E" group="E" teamz={['ESP', 'GER', 'JPN', 'CRC']} pickz={['E1', 'E2']} />
            <GroupM name="Group F" group="F" teamz={['BEL', 'CAN', 'MAR', 'CRO']} pickz={['F1', 'F2']} />
            <GroupM name="Group G" group="G" teamz={['BRA', 'SRB', 'SUI', 'CMR']} pickz={['G1', 'G2']} />
            <GroupM name="Group H" group="H" teamz={['PRT', 'GHA', 'URU', 'KOR']} pickz={['H1', 'H2']} />
          </div>
        )}
      />

    </Switch>
    )}
  </div>
);
Groups.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Groups);
